import { EmployeeApi } from "../api"

export class Employee {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }
  static async createEmployee(formData) {
    const { data } = await EmployeeApi.createEmployee(formData);
    return new Employee(data.result)
  }
  static async removeEmployee(id) {
    const { data } = await EmployeeApi.removeEmployee(id);
    return data
  }
  static async getEmployeeByProject(projectId) {
    const { data } = await EmployeeApi.getEmployeeByProject(projectId);
    return data.result.map(item => new Employee(item));
  }
  static async updateEmployee(formData) {
    const { data } = await EmployeeApi.updateEmployee(formData);
    return new Employee(data.result)
  }
}